import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { UsuarioOld } from '@app/shared/interfaces/usuario.interface';
import { PrimengSharedModule } from '@app/shared/primeng/primeng-shared/primeng-shared.module';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-picklist-lineaservicio',
    standalone: false,
    templateUrl: './picklist-lineaservicio.component.html',
    styleUrl: './picklist-lineaservicio.component.scss'
})
export class PicklistLineaservicioComponent {
    public ref = inject(DynamicDialogRef);
    public config = inject(DynamicDialogConfig);

    ngOnInit(): void {
        this.targetUsuarios = this.config.data?.selectedUsuario ?? [];
        this.sourceUsuarios = (this.config.data?.usuarios as UsuarioOld[])?.filter((usuario) => !this.targetUsuarios.some((tUsuario) => tUsuario.id == usuario.id)) ?? [];
    }

    sourceUsuarios: UsuarioOld[] = [];
    targetUsuarios: UsuarioOld[] = [];

    trackById(index: number, item: any): any {
        return item.id;
    }

    guardar() {
        this.ref.close(this.targetUsuarios);
    }

    cancelar() {
        this.ref.close();
    }
}
